/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ProducerInputs */

const en_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producer / Château`)
};

const es_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productor / Château`)
};

const fr_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producteur / Château`)
};

const de_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produzent / Weingut`)
};

const ja_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生産者 / シャトー`)
};

const zh_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产商 / 酒庄`)
};

const ar_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنتج / القصر`)
};

const id_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produsen / Château`)
};

const it_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produttore / Château`)
};

const ru_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Производитель / Шато`)
};

const pt_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produtor / Château`)
};

const ko_field_producer = /** @type {(inputs: Field_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생산자 / 샤토`)
};

/**
* | output |
* | --- |
* | "Producer / Château" |
*
* @param {Field_ProducerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_producer = /** @type {((inputs?: Field_ProducerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ProducerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_producer(inputs)
	if (locale === "es") return es_field_producer(inputs)
	if (locale === "fr") return fr_field_producer(inputs)
	if (locale === "de") return de_field_producer(inputs)
	if (locale === "ja") return ja_field_producer(inputs)
	if (locale === "zh") return zh_field_producer(inputs)
	if (locale === "ar") return ar_field_producer(inputs)
	if (locale === "id") return id_field_producer(inputs)
	if (locale === "it") return it_field_producer(inputs)
	if (locale === "ru") return ru_field_producer(inputs)
	if (locale === "pt") return pt_field_producer(inputs)
	return ko_field_producer(inputs)
});